/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Address {
  readonly first_line: string;
  readonly second_line: string;
  readonly third_line: string;
  readonly post_code: string;
  readonly city: string;
  readonly county: string;
  readonly country: string;
}
